import React, { useState, useRef, useEffect } from "react";
import { Formik } from "formik";
import { Button, FormGroup, Label, Row, Col, Input } from "reactstrap";
import { cloneDeep } from "lodash";
import * as Yup from "yup";
import CoveredEntity from "components/CoveredEntity";
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";

// const validationSchema = Yup.object({
//   coveredEntityName: Yup.string().required("Please select covered entity"),
// });


let coveredentityError = ""


const LocationStatusObt = [
  { id: "", label: "Location Research Required" },
  { id: "Y", label: "Eligible" },
  { id: "N", label: "Ineligible" },
];

const SearchContainer = ({
  handleUpdateEntity,
  onSearch,
  onReset,
  initialValue,
  orgId,
  onCoverdEntityChange,
  selectedCEId,
  setCEList,
}) => {
  const formikRef = useRef();
  const [selectedEligibleFlag, setSelectEdeligibleFlag] = useState(
    selectedCEId !== "" ? "" : "-1"
  );
  const [selectedCE, setSelectedCE] = useState(selectedCEId);

  // useEffect(() => {
  //   if (selectedCEId && formikRef.current) {
  //     const { setFieldValue } = formikRef.current;
  //     setFieldValue("coveredEntityName", selectedCEId);
  //     const param = { coveredEntityName: selectedCEId };
  //     handleSubmit(param);
  //   }
  // }, [selectedCEId]);

  useEffect(() => {
    coveredentityError = ""
    setSelectedCE("")
    
  }, [orgId])


  const handleSubmit = async (val) => {
    //const { setSubmitting } = actions;
    const values = cloneDeep(val);
    values.eligibleFlag = selectedEligibleFlag;
    if (selectedCE == "" && window.selectedCoveredEntittyId == "") {
      coveredentityError = "Please select Covered Entity"
    }
    await onSearch(values);
    //setSubmitting(false);
  };

  const handleCoverdEntityChange = async (
    value,
    coveredEnty,
    setFieldValue
  ) => {
    coveredentityError = ""
    window.selectedCoveredEntittyId = value;

    handleUpdateEntity(coveredEnty);
    setFieldValue("coveredEntityName", value);
    setSelectedCE(value);
    if (selectedCEId) {
      let param = {};
      param.coveredEntityName = value;
      await handleSubmit(param);
    }


  };

  const onLocationReset = () => {
    setSelectEdeligibleFlag("-1");
    onReset();
    setSelectedCE("");
    coveredentityError = "";
    window.selectedCoveredEntittyId = "";
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        onSubmit={handleSubmit}
        initialValues={initialValue}
        // validationSchema={validationSchema}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue } =
            props;
          return (
            <div>
              <h5 className="f-16 text-primary font-weight-700">
                Search Locations
              </h5>
              <Row sm={5}>
                <Col md={3} sm={3} xs={6}>
                  {" "}
                  <FormGroup>
                    <Label for="coveredEntityID">Covered Entity</Label>
                    <CoveredEntity
                      value={selectedCE}
                      orgId={orgId}
                      name="coveredEntityName"
                      onChange={(value, coveredEnty) =>
                        handleCoverdEntityChange(
                          value,
                          coveredEnty,
                          setFieldValue
                        )
                      }
                    />
                    {(coveredentityError.length > 0) ? (<div className="text-danger f-12 ">
                      {coveredentityError}
                    </div>) : null}
                  </FormGroup>
                </Col>
                <Col md={3} sm={3} xs={6}>
                  <FormGroup>
                    <Label>Location Status</Label>
                    <Input
                      id="eligibleFlag"
                      name="eligibleFlag"
                      type="select"
                      value={selectedEligibleFlag}
                      onChange={(e) => {
                        setSelectEdeligibleFlag(e.target.value);
                      }}
                    >
                      <option value={"-1"}>--Select--</option>
                      {LocationStatusObt.map((status) => {
                        const { id, label } = status;
                        return (
                          <option key={id} value={id}>
                            {label}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-end">
                <Col md="auto" className="">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="search"
                  >
                    <span className="right_5">
                      <img src={search} alt="" />
                    </span>{" "}
                    Search
                  </Button>
                  <Button
                    color="primary"
                    className="reset ms-2"
                    onClick={() => {
                      resetForm();
                      onLocationReset();
                    }}
                  >
                    <span className="right_5">
                      <img src={reseticon} alt="" />
                    </span>{" "}
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    </>
  );
};

export default SearchContainer;
